// extracted by mini-css-extract-plugin
export var avatar = "_qq-3";
export var avatarContainer = "_qq-2";
export var avatarSpacer = "_qq-5";
export var avatarSpacerContainer = "_qq-4";
export var avatarStackContainer = "_qq-1";
export var bubble = "_qq-0";
export var remainderBubble = "_qq-6";